<template>
	<modal @close="cancel" dialog="modal-lg" class="dark-top" :header="false" :customClass="'heightAuto'" :footer="true">
		<div slot="body" class="p-4">
			<div v-if="getIsLoadingReasons" class="d-flex justify-content-center">
				<loader size="small"></loader>
			</div>
			<div v-else>
				<div v-if="isToShowTopMessage">
					<h2 class="text-center mb-3">What do you want to do?</h2>
					<div class="d-flex h-100 justify-content-between align-items-center py-4">
						<button  @click="clickedCancelBookingNow()" :class="{ 'bg-light': choosedCancelNow, 'bg-lightest': !choosedCancelNow }" class="w-100 w-100 mb-2 bg-lightest color-6 text-center font-weight-600 py-3 border-light radius-normal pointer">Cancel Booking Now</button>
						<div class="w-25 d-flex justify-content-center"><span> - OR - </span></div>
						<button @click="clickedRequestCancelBooking()" :class="{ 'bg-light': choosedRequest, 'bg-lightest': !choosedRequest }" class="w-100 w-100 mb-2 bg-lightest color-6 text-center font-weight-600 py-3 border-light radius-normal pointer">Request Cancelation</button>
					</div>

					<div v-if="choosedCancelNow">You choosed cancel now! This means that we will not notify {{ reservation.channelTypeDescription}}. This booking will be immediately cancelled.</div>
					<div v-if="choosedRequest">
						<p class="mb-3">
						Please type a reason for this cancellation request. We will notify {{ reservation.channelTypeDescription}} with this.
						</p>
					</div>
				</div>

				<!-- choose cancellation reason -->
				<div class="mt-3">
					<label for="cancellationReason">
						Cancellation reason
						<span v-if="isFoundReasonsAllBookings" class="color-6">*</span>
					</label>

					<v-select
						id="cancellationReason"
						v-if="filteredReasons.length > 0"
						v-model="reasonObject"
						:options="filteredReasons"
						:reduce="reason => reason.id"
						label="description" placeholder="Select a reason"
						@input="updateReason(reasonObject)"
					></v-select>

					<label v-if="!!reasonObject && !reservation.cancelationReasonId" class="full mt-1">
						Cancellation description
						<span v-if="isFoundReasonsAllBookings" class="color-6">*</span>
						<textarea ref="cancelationNote" class="bg-lighter w-100 mt-1" rows="2" v-model="reservation.cancelationNote" autofocus></textarea>
					</label>
				</div>
			</div>
		</div>

		<div slot="footer" class="d-flex flex-all">
			<button type="button" class="btn cancel wider" @click="cancel">Cancel</button>
			<button type="button" class="btn ok wider" @click="continueAndClose" :disabled="isInvalidValid || getIsLoadingReasons">
				<span>Continue</span>
			</button>
			<button v-if="defaultCancelPaymentTypeName !== null" type="button" class="btn ok wider" @click="continueToOptionModal" :disabled="isInvalidValid || getIsLoadingReasons || !refundsOrPayOutAllowed">
				Continue to {{ defaultCancelPaymentTypeName }}
			</button>
		</div>
	</modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { reservationsMixin } from '@/mixins/reservations'
import Modal from './Modal'
import extendedVSelect from '@/extends/vue-select'
import Loader from '@/tools/loaders/loader1'

export default {
	mixins: [
		reservationsMixin
	],
	async mounted() {
		this.handleMounted();
		this.$nextTick(() => {
			this.$refs.cancelationNote && this.$refs.cancelationNote.focus(); // focus on the textarea

			this.eventHub.$on("closeTargetModal", () => {
				this.cancel();
			});
		});
	},
	destroyed(){
		this.eventHub.$off('closeTargetModal');
	},
	data() {
		return {
			isDisabled: true,
			updatedForm: null,
			reservation: null,
			choosedRequest: false,
			choosedCancelNow: false,
			reasonObject: null,
			defaultOtherReasonObject: {
				description: 'Other',
				cancelationReasonType: -9999, // -9999 type doesn't exist
				id: null
			},
		}
	},
	computed: {
		...mapGetters([
			'getSelectedReservation',
			'getCompanySettings',
			'getPaymentCancelTypeOptions',
			'getReasons',
			'getIsLoadingReasons',
			'getReservationCancelNowOrRequest',
			'isFoundReasonsAllBookings',
			'getReasonsAllBookings',
		]),
		refundsOrPayOutAllowed() {
            return (this.reservation.billing.payments && this.reservation.billing.payments.length > 0 && this.reservation.billing.payments.some(p => p.paymentDirection === 0));
        },
		filteredReasons() {
			return [...this.getReasonsAllBookings, this.defaultOtherReasonObject];
		},
		isInvalidValid() {
			if (!this.userSelectedReason) return true;

			if (!this.isToShowTopMessage || this.userSelectedReason) {
				return false;
			} else {
				if (this.choosedCancelNow) return false;

				return this.getSelectedReservation.cancelationNote == '' || this.getSelectedReservation.cancelationNote == null ||  typeof this.getSelectedReservation.cancelationNote == "undefined";
			}
		},
		isToShowTopMessage() {
			if (this.reservation && this.reservation.channelType == 202) return true;
			
			return false;
		},
		defaultCancelPaymentTypeId(){
			return this.getCompanySettings
			&& this.getCompanySettings.settingsPresets
			&& this.getCompanySettings.settingsPresets.defaultPaymentCancelationType // 0 = Payout, 1 = Refund
		},
		defaultCancelPaymentTypeName() {
			/**
			 * Code refactored to avoid TypeError:'Cannot read properties of null (reading 'name')'
			 */
			try {
				if ((this.defaultCancelPaymentTypeId == null || typeof this.defaultCancelPaymentTypeId == "undefined") || !this.getPaymentCancelTypeOptions) {
					return null;
				}
				const defaultCancelPaymentType = this.getPaymentCancelTypeOptions.find( (option) => option.id === this.defaultCancelPaymentTypeId);
				if (!defaultCancelPaymentType) return null;

				return defaultCancelPaymentType.name;
			} catch (error) {};
			
			return null;
		},
		userSelectedReason() {
			const char = 3;

			if (this.isFoundReasonsAllBookings) {
				if (!this.reasonObject) return false;
				if (this.reservation.cancelationReasonId == null && !!this.reservation.cancelationNote && this.reservation.cancelationNote.length > char -1) return true;
				
				return !!this.reservation.cancelationReasonId;
			} else {
				return true; // if we don't have any cancellation reasons, then we can select other, user can save it
			}
		}
	},
	methods: {
		...mapActions([
			'openModal',
			'closeModal',
			'setReservationCancelNow',
			'setReservationCancelNowOrRequest',
		]),
		clickedRequestCancelBooking() {
			this.setReservationCancelNowOrRequest('request');
			this.choosedRequest = true;
			this.choosedCancelNow = false;
		},
		clickedCancelBookingNow() {
			this.setReservationCancelNowOrRequest('now');
			this.choosedRequest = false;
			this.choosedCancelNow = true;
		},
		cancel() {
			this.reservation.changeStatusTo = null;
			
			this.closeModal();
		},
		updateReason(reason) {
			if (reason.id === null) {
				this.reservation.cancelationNote = null; // start null. As the user start typing it will have a value
			}
			this.reservation.cancelationReasonId = reason.id;

			this.$nextTick(() => {
				this.$refs.cancelationNote && this.$refs.cancelationNote.focus(); // focus on the textarea
			})
		},
		continueAndClose() {
			if(this.isToShowTopMessage) {
				this.setReservationCancelNow(this.choosedCancelNow); // will be true or false, by default it's true in vuex store
			}

			// Ask to open Pay out
			this.setReservationToCancel(false);
			this.closeModal();
		},
		continueToOptionModal() {
			if(this.isToShowTopMessage) {
				this.setReservationCancelNow(this.choosedCancelNow); // will be true or false, by default it's true in vuex store
			}

			// Ask to open Pay out
			this.setReservationToCancel(false);
			this.closeModal();

			const optionModal = this.defaultCancelPaymentTypeId === 0 ? 'ReservationPayOut' : 'ReservationRefund'; // 0 = Payout, 1 = Refund
			this.openModal(optionModal); // open modal based on default Cancel Payment Type defined in company settings presets
		},
		handleMounted() {
			if (!this.getSelectedReservation.cancelationNote) {
				this.$set(this.getSelectedReservation, "cancelationNote", null);
			}

			this.reservation = this.getSelectedReservation;

			if (!!this.getReservationCancelNowOrRequest) {
				if (this.getReservationCancelNowOrRequest === "now") this.choosedCancelNow = true;
				if (this.getReservationCancelNowOrRequest === "request") this.choosedRequest = true;
			}

			if (!this.getIsLoadingReasons) {
				if (this.isFoundReasonsAllBookings) {
					// if cancellationReasonId is set, then set the reasonObject based on the id
					if (!!this.reservation.cancelationReasonId) {
						this.reasonObject = this.getReasons.find(
							(reason) => reason.id == this.reservation.cancelationReasonId
						);
					}

					// if canceled and cancellationReasonId is null and cancelationNote is not null, then set the reasonObject to Other reason
					if (this.reservation.cancelationReasonId === null && !!this.reservation.cancelationNote) {
						this.reasonObject = this.filteredReasons.find(
							(reason) => reason.id == this.reservation.cancelationReasonId
						);
					}
				} else {
					this.reasonObject = this.defaultOtherReasonObject;
				}
			}
		},
	},
	components: {
		Modal,
		Loader,
		vSelect: extendedVSelect,
	},
};
</script>



// WEBPACK FOOTER //
// ReservationCancelReason.vue?46dba350